import { css } from '@linaria/core';
import media from '../primitives/Media';
export const FontSizes = css `
	:global(html) {
		font-size: 16px;

		${media('min', 'l')} {
			font-size: 18px;
		}

		/* Adjust font size */
		font-size: 100%;
		-webkit-text-size-adjust: 100%;
		/* Font varient */
		font-variant-ligatures: none;
		-webkit-font-variant-ligatures: none;
		/* Smoothing */
		text-rendering: optimizeLegibility;
		-moz-osx-font-smoothing: grayscale;
		font-smoothing: antialiased;
		-webkit-font-smoothing: antialiased;
		/* ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
		text-shadow: rgba(0, 0, 0, 0.01) 0 0 1px;
	}
`;
